import { PhotoAspect, PhotoMimetype, PhotoPreviewEntity } from 'mk2/schemas';

function getLoadedImage(f): Promise<HTMLImageElement> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e: ProgressEvent) => {
            const fr = e.currentTarget as FileReader;
            const image = new Image();
            image.src = fr.result as string;
            image.onload = () => {
                resolve(image);
            };
            image.onerror = (err) => { reject(err); };
        };
        reader.onerror = (err) => { reject(err); };
        reader.readAsDataURL(f);
    });
}

export async function getPhotoPreview(f) {
    let pp: PhotoPreviewEntity = null;
    if (f) {
        const image = await getLoadedImage(f);
        let mimetype = null;
        switch (f.name.slice(-4)) {
            case '.gif': mimetype = PhotoMimetype.GIF; break;
            case '.png': mimetype = PhotoMimetype.PNG; break;
            case '.jpg': mimetype = PhotoMimetype.JPEG; break;
            default: mimetype = null;
        }
        switch (f.name.slice(-5)) {
            case 'jpeg': mimetype = PhotoMimetype.JPEG; break;
        }
        pp = {
            id: f.name,
            fileName: f.name,
            imgBase64Data: image.src,
            originalWidth: image.width,
            originalHeight: image.height,
            aspect: image.width === image.height ? PhotoAspect.SQUARE :
                (image.width >= image.height ?
                    PhotoAspect.LANDSCAPE :
                    PhotoAspect.PORTRAIT),
            mimetype,
        };

    }
    if (pp) {
        return pp;
    } else {
        throw new Error('image load error');
    }
}

export function getExifOrientation(data: ArrayBuffer) {
    const view = new DataView(data);

    if (view.getUint16(0, false) !== 0xFFD8) {
        return -2; // Not JPEG
    }

    const length = view.byteLength;
    let offset = 2;
    while (offset < length) {
        if (view.getUint16(offset + 2, false) <= 8) {
            return -1;
        }

        const marker = view.getUint16(offset, false);
        offset += 2;
        if (marker === 0xFFE1) {
            if (view.getUint32(offset += 2, false) !== 0x45786966) {
                return -1;
            }

            const little = view.getUint16(offset += 6, false) === 0x4949;
            offset += view.getUint32(offset + 4, little);
            const tags = view.getUint16(offset, little);
            offset += 2;
            for (let i = 0; i < tags; i++) {
                if (view.getUint16(offset + (i * 12), little) === 0x0112) {
                    return view.getUint16(offset + (i * 12) + 8, little);
                }
            }
        } else if ((marker & 0xFF00) !== 0xFF00) { // tslint:disable-line no-bitwise
            break;
        } else {
            offset += view.getUint16(offset, false);
        }
    }

    return -1;
}
